import { RootState } from '../types';

export const apiDefinitionsSelector = (state: RootState) => state.api?.apiDefinitions ?? [];
export const apiLoadingSelector = (state: RootState) => state.api?.loading ?? false;
export const apiErrorSelector = (state: RootState) => state.api?.error ?? null;
